import { getCurrentUser } from '@/lib/auth-utils'
import { ROLE_ADMIN } from '@/lib/permissions'
import type { UserPreference } from '@/models'
import { neon } from '@/services/neon'

function verifyCaller(userId: string) {
  const user = getCurrentUser()
  if (!user?.id) throw new Error('User not authenticated.')
  if (user.role !== ROLE_ADMIN && user.id !== userId) {
    throw new Error('You can only access your own preferences.')
  }
}

export async function getPreference(userId: string): Promise<UserPreference | null> {
  verifyCaller(userId)

  const { data, error } = await neon
    .from('user_preferences')
    .select('*')
    .eq('user_id', userId)
    .single()

  if (error) {
    if (error.message?.includes('Results contain 0 rows')) {
      return null
    }
    throw new Error(error.message)
  }

  return data as UserPreference
}

export async function upsertPreference(
  userId: string,
  data: {
    booking_view_mode?: 'list' | 'calendar'
    app_theme?: 'light' | 'dark' | 'system'
    notification_preferences?: Record<string, boolean>
  },
): Promise<UserPreference> {
  verifyCaller(userId)

  const payload: Record<string, any> = { user_id: userId }

  if (data.booking_view_mode) {
    payload.booking_view_mode = data.booking_view_mode
  }
  if (data.app_theme) {
    payload.app_theme = data.app_theme
  }
  if (data.notification_preferences) {
    payload.notification_preferences = data.notification_preferences
  }

  const { data: result, error } = await neon
    .from('user_preferences')
    .upsert(payload, { onConflict: 'user_id' })
    .select()
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return result as UserPreference
}
